const DynamicSaveBar = (props) => (
  <div className='dynamic-save-bar'>
    <div className='pull-right'>
      <button className='btn btn-default js-cancel'
        onClick={() => props.cancelCallback()} >
        Cancel
      </button>
      <button onClick={() => props.saveCallback()} className={`btn btn-success ${props.isLoading ? 'is--loading' : ''}`}>
        <div className='btn--loader' />
        <span className='btn__hide-when-loading'>Save Changes</span>
      </button>
    </div>
  </div>
)

export default DynamicSaveBar
